import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './reports.css';

const Reports = () => {
  const { t } = useTranslation();

  const reportsList = [
    {
      id: 'daily-appointments',
      title: t('reports.dailyAppointments.title'),
      description: t('reports.dailyAppointments.description'),
      icon: '📅',
      path: '/reports/daily-appointments'
    },
    {
      id: 'doctor-revenue',
      title: t('reports.doctorRevenue.title'),
      description: t('reports.doctorRevenue.description'),
      icon: '💰',
      path: '/reports/doctor-revenue'
    },
    {
      id: 'sales-invoices',
      title: t('reports.salesInvoices.title'),
      description: t('reports.salesInvoices.description'),
      icon: '📊',
      path: '/reports/sales-invoices'
    },
    {
      id: 'vat-reports',
      title: t('reports.vatReports.title'),
      description: t('reports.vatReports.description'),
      icon: '🧾',
      path: '/reports/vat-reports'
    },
    {
      id: 'credit-notes',
      title: t('reports.creditNotes.title'),
      description: t('reports.creditNotes.description'),
      icon: '📋',
      path: '/reports/credit-notes'
    },
    {
      id: 'doctor-account',
      title: t('reports.doctorAccount.title'),
      description: t('reports.doctorAccount.description'),
      icon: '👨‍⚕️',
      path: '/reports/doctor-account'
    }
  ];

  return (
    <div className="container tables bg-white mt-5">
      <div className="tableTitle">
        <h3>{t('reports.title')}</h3>
      </div>

      <div className="reports-grid">
        {reportsList.map((report) => (
          <Link key={report.id} to={report.path} className="report-card">
            <div className="report-icon">{report.icon}</div>
            <div className="report-content">
              <h4>{report.title}</h4>
              <p>{report.description}</p>
            </div>
            <div className="report-arrow">→</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Reports;
